import React, { useState } from 'react';
import { CircularProgress, Button } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Text from '../text';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';
import { useDropzone } from 'react-dropzone';

interface UploadResultProps {}

const UploadResults: React.FC = () => {
	const [fileDetails, setFileDetails] = useState<{
		name: string;
		size: string;
	} | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		accept: '.csv' as any,
		onDrop: (acceptedFiles: any) => {
			const file = acceptedFiles[0];
			if (file) {
				const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
				setFileDetails({ name: file.name, size: `${sizeInMB} MB` });
			}
		},
	});

	return (
		<div id="upload">
			<Text addStyle="!text-[#2C2C2C] !font-futura !text-[20px] !mt-[24px] !font-[500] !mb-[10px]">
				Upload Results
			</Text>
			<Text addStyle="!text-[#2C2C2C] !font-jost !text-[16px] !mt-[24px]">
				Select a CSV file from your computer to add to the results.
			</Text>
			<div
				className={`flex flex-col justify-left mb-2 mt-2 !w-full mr-2`}
			>
				<div className="h-[215px] bg-white !w-full flex py-2">
					<div
						{...getRootProps()}
						className={`p-6 border-[1px] border-dashed border-[#9EACB4] rounded-[6px] w-full h-[215px] ${
							isDragActive
								? 'border-blue-300 bg-blue-100'
								: 'border-gray-300'
						} cursor-pointer flex justify-center items-center`}
					>
						<input {...getInputProps()} />
						{isDragActive ? (
							<p>Drop the files here ...</p>
						) : (
							<div className="relative mt-[30px]">
								<img
									src="/assets/icons/upload-icon.svg"
									alt="Drawer Icon"
									className="absolute top-[-30px] left-1/2 transform -translate-x-1/2 -translate-y-1/2"
								/>
								Drag & Drop or{' '}
								<span className="text-[#0092C8]">
									Choose file
								</span>{' '}
								to upload
							</div>
						)}
					</div>
				</div>

				<div className="flex mt-2 items-center">
					<label className="flex items-center">
						<input
							type="file"
							style={{
								opacity: 0,
								position: 'absolute',
								zIndex: -1,
							}}
							onChange={(e) => {
								const file = e.target.files?.[0];
								if (file) {
									const sizeInMB = (
										file.size /
										(1024 * 1024)
									).toFixed(2);
									setFileDetails({
										name: file.name,
										size: `${sizeInMB} MB`,
									});
								}
							}}
						/>
						<SecondaryButton addStyle="!w-[200px] !h-[36px]">
							{fileDetails ? fileDetails.name : 'Choose File'}
						</SecondaryButton>
						{fileDetails && (
							<span className="ml-4">({fileDetails.size})</span>
						)}
					</label>
				</div>

				<div className="flex justify-end mt-4 space-x-1 items-center">
					<Button
						onClick={() => {}}
						color="primary"
						className="!text-[#9EACB4]"
					>
						CANCEL
					</Button>
					{isLoading ? (
						<CircularProgress
							sx={{ color: '#0092C8' }}
							size={22}
							className="!mr-5"
						/>
					) : (
						<PrimaryButton
							addStyle="!h-[36px] !w-[68px]"
							onClick={() => {}}
						>
							SAVE
						</PrimaryButton>
					)}
				</div>
			</div>
		</div>
	);
};

export default UploadResults;
